export const softText = [
    "IStellar Team of ColdFusion developers are experts in developing web applications in CFML that meet your business needs and help you make processes more efficient. Most of our team members are either Brainbench or Adobe certified ColdFusion developers. For over 13 years, We've been serving clients all over the world for their CFML projects -- and for their business. Our team is dedicated to giving special attention to detail and design to create unique UI/UX experience to your content management systems, custom database development & e-commerce solutions.",
    "We develop new applications, maintain, optimize existing applications in all major CFML application servers ColdFusion, Lucee, Railo and Open BlueDragon. We have expertise experience in building applications with all latest application frameworks like ColdBox, CFWheels, Framework one(FW/1), Mach-II, Fusebox, ColdSpring, etc.",
    "Our team of developers with vast experience, have developed web applications integrated with major database platforms such as Oracle, MS SQL, MySQL, MS Access, etc."
]
export const softTestList = [
    "If you are looking for a talented team of ColdFusion programmers, then you should seriously consider IStellar team. We worked with IStellar for over a year in developing nearly a dozen ColdFusion applications for streamlining our company's workflow. They were able to meet my deadlines and were able to create some very complex applications, many of which involved drag and drop style user interfaces",
]

export const column1 = [
    {  
        ul: [
            {li: "ColdFusion App Migration",
            path: "/services/coldfusion-app-migration"},
            {li: "MuraCMS Expertise",
            path: "/services/muracms-expertise"},
            {li: "MuraCMS Plugin Creation & Personalization",
            path: "/services/muracms-plugin-creation&personalization"},
            {li: "ColdFusion Hosting & Support",
            path: "/services/coldfusion-devlopment"},
            {li: "ColdFusion Legacy App Maintenance",
            path: "/services/coldfusion-angular-devlopment"},   
        ]
        }
]
export const dualList1 = [
    {
        listHead: "CFML:",
        ul: [
            { li: "Adobe ColdFusion 8, 9, 10, 11" },
            { li: "Lucee" },
            { li: "Brand new ColdFusion 2016" },
            { li: "Railo" },
            { li: "openDB" },
        ]
    }, {
        listHead: "Databases:",
        ul: [
            { li: "MS SQL Server:" },
            { li: "MySQL" },
            { li: "PostgreSQL" },
            { li: "MariaDB" },
            { li: "Oracle" },
            { li: "MS Access" },
            { li: "MongoDB" }
        ]
    }
]
export const dualList2=[
    {
        listHead: "CF Open Source:",
        ul: [
            { li: "JavaScript" },
            { li: "AJAX" },
            { li: "jQuery" },
            { li: "jQuery Core" },
            { li: "jQuery UI" },
            { li: "jQuery Mobile" },
            { li: "AngularJS" },
            { li: "BackboneJS" },
            { li: "ExtJS" },
        ]
    },
    {
        listHead: "Client Side Script:",
        ul: [
            { li: "MuraCMS" },
            { li: "ContentBox" },
            { li: "PresideCMS" },
            { li: "MangoBlog" },
            { li: "BlogCFC" },
            { li: "Galleon forum" },
        ]
    }
]
export const dualList3=[
        {
        listHead: "CF Frameworks:",
        ul: [
            { li: "ColdBox family" },
            { li: "CFWheels" },
            { li: "Mach-II" },
            { li: "Fusebox" },
            { li: "ColdSpring" },
            { li: "Framework one family" },
            { li: "FW/1" },
            { li: "Inject One(DI/1)" },
            { li: "AOP/1" },
        ]
    },
    {
        listHead: "Version control:",
        ul: [
            { li: "GIT" },
            { li: "SVN" },
            { li: "VSS" },
        ]
    }

]

export const column2 = [
    "Chief Executive Officer / Co-Owner",
    "Summit Design Studio",
    "Lewisburg, Pennsylvania",
]


export const column3 = [
  {  
ul: [
    {li: "eCommerce / shopping cart Solutions",
    path: "/services/shopping-cart-solutions"},
    {li: "Payment Gateway integrations",
    path: "/services/payment-gateway-solutions"},
    {li: "Shipping API integrations",
    path: "/services/shipping-api-integrations"},
    {li: "ColdFusion Development Services",
    path: "/services/coldfusion-devlopment"},
    {li: "ColdFusion AngularJS development",
    path: "/services/coldfusion-angular-devlopment"},
    {li: "ColdFusion REST API development",
    path: "/services/coldfusion-rest-api-devlopment"},
]
}
]

export const column4 = [
    "Education / LMS / E-Learning / Training",
    "Finance",
    "Retail & E-Commerce",
    "Real Estate",
]


export const blankPara = [
    ""
]




export const Contact = [
    "If you have small ad-hoc task or bigger team project or your dream product idea in CFML ( Adobe ColdFusion / Lucee / Railo ), please don't hesitate to keep in touch with us.",
    "To discuss about our CFML ( Adobe ColdFusion / Lucee / Railo ) expertise and services, please mail us on business@mitrahsoft.com or call +1 (817) 606-8684 / +91 9092480924",
]